import * as React from 'react';
import { memo } from 'react';
import { FormLabelPropsType } from './form.types';

import { cn } from '@restworld/utils-common';
export const FormLabelWrapper = memo(({ label, id, disabled, children, isFullWidth }: FormLabelPropsType) => (
  <Wrapper $isFullWidth={isFullWidth}>
    {label ? (
      <LabelWrapper>
        <StyledLabel htmlFor={id} disabled={disabled}>
          {label}
        </StyledLabel>
      </LabelWrapper>
    ) : null}
    {children}
  </Wrapper>
));
export default FormLabelWrapper;
const Wrapper = ({ $isFullWidth, className, ...props }: any) => (
  <div className={cn($isFullWidth ? 'w-full' : '', className)} {...props} />
);
const LabelWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('mb-2 block', className)} {...props} />
);
const StyledLabel = ({ disabled, className, ...props }: any) => (
  <label className={cn(disabled ? 'text-gray-400' : '', className)} {...props} />
);
